import { lazy } from 'react';

const AsyncProgramTypesListPage = lazy(() => import('./ListContainer'));

export const ProgramTypesList = () => {
  return <AsyncProgramTypesListPage />;
};
